import type { ResponseWithType, ParticipantSearchResponse } from './types';
import type { ParticipantSearch } from '../../types/events';

const participantSearch = ({
  data,
}: ResponseWithType<ParticipantSearch>): ParticipantSearchResponse => {
  return {
    __typename: 'ParticipantSearch',
    ...data,
  };
};

export default participantSearch;
